export const MAC_RE = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/;

/** Prototype `normMac(v)` (line 2812): trim, uppercase, `-` → `:`. */
export function normMac(v: string | null | undefined): string {
  return (v ?? '').trim().toUpperCase().replace(/-/g, ':');
}

/** True when the normalized value is `AA:BB:CC:DD:EE:FF` (prototype saveEmployee regex, line 3010). */
export function isValidMac(v: string | null | undefined): boolean {
  return MAC_RE.test(normMac(v));
}

/** Empty MAC is allowed (prototype); otherwise the prototype's toast text, else null. */
export function macError(raw: string | null | undefined): string | null {
  const trimmed = (raw ?? '').trim();
  if (!trimmed) return null;
  return isValidMac(trimmed) ? null : 'MAC adresa nuk është valide';
}

/** Prototype duplicate-MAC toast: `Kjo MAC adresë është e lidhur me <emri>`. */
export function macDuplicateError(employeeName: string): string {
  return 'Kjo MAC adresë është e lidhur me ' + employeeName;
}
